<template>
  <div>
    <v-autocomplete
      v-model="selectedId"
      :items="availableBatches"
      item-title="title"
      item-value="id"
      label="Lote"
      placeholder="Busque por lote o lugar"
      clearable
      :rules="required ? [requiredRule] : []"
      :loading="loading"
      no-data-text="No hay lotes disponibles"
    />

    <v-sheet v-if="selectedBatch" class="pa-4 selected-summary" rounded border>
      <div class="text-subtitle-1 font-weight-medium mb-2">Lote seleccionado</div>
      <div><strong>Nombre:</strong> {{ selectedBatch.name }}</div>
      <div><strong>Lugar:</strong> {{ selectedBatch.locationName }}</div>
      <div><strong>Hectareas:</strong> {{ selectedBatch.haAmount || '-' }}</div>
      <div v-if="selectedBatch.note"><strong>Notas:</strong> {{ selectedBatch.note }}</div>
    </v-sheet>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LandBatchSelector',
  props: {
    modelValue: Object,
    required: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue'],
  data: () => ({
    loading: false,
    requiredRule: value => Number(value) > 0 || 'Debe seleccionar un lote.'
  }),
  computed: {
    ...mapGetters('landBatchModule', ['getBatchesByLocation']),
    availableBatches () {
      return (this.getBatchesByLocation || []).flatMap(location =>
        (location.children || []).map(batch => ({
          id: Number(batch.id),
          batch: { ...batch, parentId: location.id },
          name: batch.name,
          haAmount: batch.haAmount,
          note: batch.note,
          locationName: location.name,
          title: `${batch.name} - ${location.name}`
        }))
      )
    },
    selectedBatch () {
      const id = Number(this.modelValue?.id)
      return this.availableBatches.find(batch => batch.id === id) || null
    },
    selectedId: {
      get () {
        const id = Number(this.modelValue?.id)
        return id > 0 ? id : null
      },
      set (id) {
        const option = this.availableBatches.find(item => item.id === Number(id))
        this.$emit('update:modelValue', option ? option.batch : null)
      }
    }
  },
  async created () {
    this.loading = true
    try {
      await this.$store.dispatch('landBatchModule/getBatchesByLocation')
    } finally {
      this.loading = false
    }
  }
}
</script>
